export enum ClientType {
  Host = 'HOST',
  Player = 'PLAYER',
}
